<div ngbDropdown class="d-inline-block" [ngClass]="{'hideArrow': !canChangeStatus()}">
  <button type="button" class="btn btn-sm" id="dropdownBasic1" [disabled]="!status || !canChangeStatus()"
    ngbDropdownToggle [ngClass]="getStatusClass()">
    {{ getStatusLabel() }}
  </button>
  <div *ngIf="status" ngbDropdownMenu aria-labelledby="dropdownBasic1">
    @if(page=="contact"){
    <ng-container *ngFor="let option of statusOptions">
      <button *ngIf="option.value != 'PENDING' && option.value != status" (click)="updateStatus(option.value)"
        ngbDropdownItem [ngClass]="option.class">
        {{ option.label | translate }}
      </button>
    </ng-container>}
    @else{
    <ng-container *ngFor="let option of optionsOfStatus">
      <button [disabled]="!canChangeStatus()" (click)="updateStatus(option.value)" ngbDropdownItem
        [ngClass]="option.class">
        {{ option.label | translate }}</button></ng-container>
    }
  </div>
</div>